<div class="admin-dialog">
  <!-- Header -->
  <div class="admin-dialog__header">
    <div class="admin-dialog__header-left admin-dialog__header-left--column">
      <h2 class="admin-dialog__title" i18n="@@adminSection.contributorPicker.title.selectContributor">担当多職種スタッフを選択</h2>
      <p class="admin-dialog__subtitle">{{userName}} さんに閲覧権限を付与するスタッフを選択</p>
    </div>
    <button mat-icon-button class="admin-dialog__close" (click)="onCancelClick()" aria-label="Close dialog" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="admin-dialog__content">
    @if (isLoading()) {
      <!-- Skeleton Loading -->
      <div class="skeleton-form">
        <!-- Filter Section Skeleton -->
        <div class="skeleton-section">
          <div class="skeleton skeleton--label"></div>
          <div class="skeleton-chips">
            <div class="skeleton skeleton--chip"></div>
            <div class="skeleton skeleton--chip"></div>
            <div class="skeleton skeleton--chip"></div>
            <div class="skeleton skeleton--chip"></div>
          </div>
          <div class="skeleton skeleton--search-box"></div>
        </div>

        <!-- List Section Skeleton -->
        <div class="skeleton-section">
          <div class="skeleton skeleton--label"></div>
          <div class="skeleton-list-box">
            <div class="skeleton skeleton--list-item"></div>
            <div class="skeleton skeleton--list-item"></div>
            <div class="skeleton skeleton--list-item"></div>
            <div class="skeleton skeleton--list-item"></div>
            <div class="skeleton skeleton--list-item"></div>
          </div>
        </div>
      </div>
    } @else {
      <!-- Filter Section -->
      <div class="dialog-section">
        <label class="dialog-section__label" i18n="@@adminSection.contributorPicker.label.filterByJob">職種でフィルター</label>
        <div class="filter-chips">
          @for (jobTitle of common.staffJobTitles; track jobTitle.code) {
            <label class="filter-chip"
                   [class.filter-chip--selected]="isJobTitleSelected(jobTitle.code)"
                   (click)="toggleJobTitleFilter(jobTitle.code)">
              {{jobTitle.desc}}
            </label>
          }
        </div>

        <div class="admin-search-box">
          <mat-icon>search</mat-icon>
          <input type="text"
                 [(ngModel)]="filterText"
                 (ngModelChange)="applyFilter2Contributors()"
                 placeholder="氏名や役職でフィルター"
                 i18n-placeholder="@@adminSection.contributorPicker.placeholder.filterText" />
        </div>
      </div>

      <!-- List Section -->
      <div class="dialog-section">
        <label class="dialog-section__label" i18n="@@adminSection.contributorPicker.label.selectTarget">多職種スタッフを選択</label>
        <div class="admin-list-box">
          @for (contributor of filteredContributors; track contributor.user.userId) {
            <div class="admin-list-box__item"
                 [class.admin-list-box__item--selected]="selectedContributorId === contributor.user.userId"
                 (click)="selectContributor(contributor.user.userId)">
              <div class="admin-list-box__item-left">
                <mat-icon class="admin-list-box__item-avatar">person</mat-icon>
                <div class="admin-list-box__item-info">
                  <span class="admin-list-box__item-name"
                        [matTooltip]="contributor.user.lastName + contributor.user.firstName"
                        matTooltipShowDelay="300">{{contributor.user.lastName}}{{contributor.user.firstName}}</span>
                  <span class="admin-list-box__item-meta">({{common.getJobTitle(contributor.attributes.jobTitleCode)}})</span>
                </div>
              </div>
              @if (selectedContributorId === contributor.user.userId) {
                <mat-icon class="admin-list-box__item-check">check_circle</mat-icon>
              }
            </div>
          }
          @if (filteredContributors?.length === 0) {
            <div class="admin-list-box__empty">
              <mat-icon>person_off</mat-icon>
              <span i18n="@@adminSection.contributorPicker.label.noResults">該当するスタッフがいません</span>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <!-- Footer -->
  <div class="admin-dialog__footer">
    <button mat-stroked-button
            (click)="onCancelClick()"
            i18n="@@adminSection.contributorPicker.button.cancel">
      キャンセル
    </button>
    <button mat-flat-button
            color="primary"
            [disabled]="!selectedContributorId"
            (click)="onAssignClick()"
            i18n="@@adminSection.contributorPicker.button.assign">
      割り当てる
    </button>
  </div>
</div>
